const pictures = [
    {Name:"TheSaviour.png","Date Added":"24/01/2024"},
    {Name:"Pints.png","Date Added":"24/01/2024"},
    {Name:"HeIsALot.png","Date Added":"24/01/2024"},
    {Name:"DatBoi.png","Date Added":"24/01/2024"},
    {Name:"FatPat.png","Date Added":"24/01/2024"},
    {Name:"Nyan.gif","Date Added":"27/01/2024"},
];
export default pictures;
